import { render } from "./MyPageReview.vue?vue&type=template&id=d0af1282"
import script from "./MyPageReview.vue?vue&type=script&lang=js"
export * from "./MyPageReview.vue?vue&type=script&lang=js"

import "./MyPageReview.vue?vue&type=style&index=0&id=d0af1282&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__